// 要認定講師フラグ一括変更画面（/admin/online-lessons/user_groups/{id}/bulk-certified-lecturer-edit）
// 「一括チェック」を押下した際に全ての対面指導のチェックを合わせる（ON → 全てON、OFF → 全てOFF）
document.addEventListener('DOMContentLoaded', function() {
    const mainCheckbox = document.getElementById('mainCheckbox');
    if (!mainCheckbox) {
        return;
    }

    mainCheckbox.addEventListener('change', function() {
        document.querySelectorAll('input[data-sub-checkbox]').forEach(function(checkbox) {
            checkbox.checked = mainCheckbox.checked;
        });
    });
});
